// Small helper for a simple SVG radar chart
export default function RadarChart({ axes, series, size = 280, max = 5 }) {
  // axes: [{label, angle?}] · series: [{name, color, values: [n], fillOpacity?}]
  const cx = size / 2, cy = size / 2;
  const radius = size / 2 - 40;
  const n = axes.length;
  const angleFor = (i) => -Math.PI / 2 + (2 * Math.PI * i) / n;
  const point = (i, v) => {
    const r = (v / max) * radius;
    return [cx + r * Math.cos(angleFor(i)), cy + r * Math.sin(angleFor(i))];
  };

  const gridRings = [1, 2, 3, 4, 5].filter(v => v <= max);
  const polygonFor = (values) => values.map((v, i) => point(i, v).join(",")).join(" ");

  return (
    <svg viewBox={`0 0 ${size} ${size}`} width="100%" style={{ maxWidth: size }}>
      {/* rings */}
      {gridRings.map(v => (
        <polygon key={v} fill="none" stroke="#E2E8F0" strokeWidth={1}
          points={axes.map((_, i) => point(i, v).join(",")).join(" ")} />
      ))}
      {/* spokes */}
      {axes.map((a, i) => (
        <line key={`spoke-${a.label || i}`} x1={cx} y1={cy} x2={point(i, max)[0]} y2={point(i, max)[1]} stroke="#E2E8F0" />
      ))}
      {/* series */}
      {series.map((s) => (
        <g key={`series-${s.name}`}>
          <polygon fill={s.color} fillOpacity={s.fillOpacity ?? 0.18} stroke={s.color} strokeWidth={2}
            points={polygonFor(s.values)} />
          {s.values.map((v, i) => {
            const [x, y] = point(i, v);
            return <circle key={`${s.name}-pt-${i}`} cx={x} cy={y} r={3} fill={s.color} />;
          })}
        </g>
      ))}
      {/* axis labels */}
      {axes.map((a, i) => {
        const [x, y] = point(i, max + 0.4);
        const anchor = Math.abs(x - cx) < 8 ? "middle" : x < cx ? "end" : "start";
        return (
          <text key={`label-${a.label || i}`} x={x} y={y} fontSize="11" fill="#475569" textAnchor={anchor} dominantBaseline="middle">
            {a.label}
          </text>
        );
      })}
    </svg>
  );
}
